/**
 * 发版后旧标签页仍引用已失效的懒加载 chunk 时，动态 import 会失败。
 * 监听相关错误并在本会话内自动整页刷新一次，以拉取新的 index.html 与资源清单。
 */

const CHUNK_RELOAD_SESSION_KEY = "room_stale_chunk_reload_once_v1";

function isChunkLoadFailureMessage(text: string): boolean {
	const t = text.toLowerCase();
	return (
		t.includes("failed to fetch dynamically imported module") ||
		t.includes("importing a module script failed") ||
		t.includes("error loading dynamically imported module") ||
		t.includes("chunk load error") ||
		(t.includes("loading css chunk") && t.includes("failed")) ||
		(t.includes("loading chunk") && t.includes("failed"))
	);
}

function getErrorMessage(reason: unknown): string {
	if (reason instanceof Error) return reason.message;
	if (typeof reason === "string") return reason;
	if (reason != null && typeof reason === "object" && "message" in reason) {
		return String((reason as { message: unknown }).message ?? "");
	}
	return String(reason ?? "");
}

function tryReloadOnceForStaleAssets(): void {
	if (typeof window === "undefined") return;
	try {
		if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === "1") return;
		sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, "1");
	} catch {
		return;
	}
	window.location.reload();
}

function scheduleClearReloadFlag(): void {
	if (typeof window === "undefined") return;
	const clear = () => {
		try {
			sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
		} catch {
			//
		}
	};
	window.addEventListener("load", () => {
		window.setTimeout(clear, 2000);
	});
}

/** 在应用入口尽早调用一次 */
export function installChunkLoadRecovery(): void {
	if (typeof window === "undefined") return;

	scheduleClearReloadFlag();

	window.addEventListener("vite:preloadError", () => {
		tryReloadOnceForStaleAssets();
	});

	window.addEventListener("unhandledrejection", (event) => {
		const msg = getErrorMessage(event.reason);
		if (!isChunkLoadFailureMessage(msg)) return;
		event.preventDefault();
		tryReloadOnceForStaleAssets();
	});

	window.addEventListener("error", (event) => {
		const msg = event.message ? String(event.message) : "";
		if (!msg && event.error) {
			const m = getErrorMessage(event.error);
			if (isChunkLoadFailureMessage(m)) {
				event.preventDefault();
				tryReloadOnceForStaleAssets();
			}
			return;
		}
		if (isChunkLoadFailureMessage(msg)) {
			event.preventDefault();
			tryReloadOnceForStaleAssets();
		}
	});
}

/**
 * React Router lazy 失败会进 route errorElement，此时不一定触发 unhandledrejection。
 */
export function maybeRecoverFromStaleChunkError(error: unknown): void {
	const msg = getErrorMessage(error);
	if (!isChunkLoadFailureMessage(msg)) return;
	tryReloadOnceForStaleAssets();
}
